import React from "react";
import FontSettings from "fantastic/components/common/controls/font/Settings";

export default ({ onChange, node, scrollToIfNeeded }) => {
  const params = {
    onChange,
    scrollToIfNeeded,
    label: i18n.t('font'),
    color: { field: "css_color", value: node.css_color },
    family: { field: "font_family", value: node.font_family },
    size: { field: "font_size", value: node.font_size }
  };

  return <FontSettings {...params} />;
};
